export const SPECIES_DISPLAY_ORDER = [
  "Canina",
  "Felina",
  "Cunícula",
  "Roedores",
  "Bovinos",
  "Equinos",
  "Suínos",
  "Avícola",
  "Primatas",
  "Peixes",
  "Répteis",
  "Anfíbios",
  "Outros",
] as const;

const SPECIES_ORDER_INDEX = new Map<string, number>(
  SPECIES_DISPLAY_ORDER.map((name, index) => [name, index]),
);

export function sortSpeciesByDisplayOrder<T extends { name?: string | null }>(items: T[]): T[] {
  return [...items].sort((left, right) => {
    const leftName = left.name ?? "";
    const rightName = right.name ?? "";
    const leftIndex = SPECIES_ORDER_INDEX.get(leftName);
    const rightIndex = SPECIES_ORDER_INDEX.get(rightName);

    if (leftIndex != null && rightIndex != null) {
      return leftIndex - rightIndex;
    }

    if (leftIndex != null) return -1;
    if (rightIndex != null) return 1;

    return leftName.localeCompare(rightName, "pt-BR");
  });
}
